import React,{useEffect, useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {DataProvider} from './GlobalState';
import MainPage from './components/Router'
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const pageStyles = {
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
};
function App() {
  return (
    <DataProvider>
      <Router>
        <div className="w-full" style={pageStyles}>
          <MainPage/>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;